import React from "react";
import styled from "styled-components";
import uuid from "uuid/v4";

const Radio = ({ name, value, disabled, onChange, defaultChecked, checked, children, ...props }) => {
  const randomID = uuid();

  return (
    <RadioContainer {...props}>
      <label htmlFor={randomID}>{children}</label>
      <input
        type="radio"
        name={name}
        id={randomID}
        value={value}
        disabled={disabled}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={checked}
        {...props}
      />
      <span aria-hidden="true" />
    </RadioContainer>
  );
};

export default Radio;

const RadioContainer = styled.div`
  position: relative;

  label {
    font-size: 16px;
    line-height: 20px;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  }

  [type="radio"]:focus ~ span {
    float: left;
    padding: 0;
    width: 27.5px;
    height: 27.5px;
    position: absolute;
    top: -1px;
    left: 0px;
    outline: 1px dashed #000;
    z-index: -9999;
  }
`;
